// globals

// ヘッダーメニュー追従
$(function(){
  const headerFixed = '.js-header-fixed';
  const scrollPoint = 800;
  let scrollTimeout = null;
  let lastScrollTop = 0; // 前回のスクロール位置を追跡する変数を追加
  const headerWrap = '.js-header';
  const headerHeight = $(headerWrap).outerHeight();

  $(window).scroll(function(){
    let scrollTop = $(this).scrollTop();
    if(scrollTop > headerHeight){
      $(headerFixed).addClass('is-fix');
      if(scrollTop > scrollPoint){
        $(headerFixed).css('top', '1rem');
      }else{
        $(headerFixed).css('top', '-' + headerHeight + 'px');
      }
    }else{
      $(headerFixed).removeClass('is-fix').css('top', 'auto');
    }

    if (scrollTimeout !== null) {
      clearTimeout(scrollTimeout);
    }

  })
})